import { Routes } from '@angular/router';

import { adminGuard } from './admin/services/admin.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'landing'
  },
  {
    path: 'landing',
    title: 'Arcane Legion',
    loadComponent: () =>
      import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'features',
    title: 'Features | Arcane Legion',
    loadComponent: () =>
      import('./pages/features-page/features-page.component').then(
        m => m.FeaturesPageComponent
      )
  },
  {
    path: 'game-modes',
    title: 'Game Modes | Arcane Legion',
    loadComponent: () =>
      import('./pages/game-modes-page/game-modes-page.component').then(
        m => m.GameModesPageComponent
      )
  },
  {
    path: 'heroes',
    title: 'Heroes | Arcane Legion',
    loadComponent: () =>
      import('./pages/heroes-page/heroes-page.component').then(
        m => m.HeroesPageComponent
      )
  },
  {
    path: 'factions',
    title: 'Factions | Arcane Legion',
    loadComponent: () =>
      import('./pages/factions-page/factions-page.component').then(
        m => m.FactionsPageComponent
      )
  },
  {
    path: 'roadmap',
    title: 'Roadmap | Arcane Legion',
    loadComponent: () =>
      import('./pages/roadmap-page/roadmap-page.component').then(
        m => m.RoadmapPageComponent
      )
  },
  {
    path: 'news',
    title: 'News | Arcane Legion',
    loadComponent: () =>
      import('./pages/news-page/news-page.component').then(
        m => m.NewsPageComponent
      )
  },

  {
    path: 'apiv1/login',
    title: 'Admin Login | Arcane Legion',
    loadComponent: () =>
      import('./admin/admin-login/admin-login.component').then(
        m => m.AdminLoginComponent
      )
  },
  {
    path: 'apiv1/admin/leads',
    title: 'Admin Leads | Arcane Legion',
    canActivate: [adminGuard],
    loadComponent: () =>
      import('./admin/admin-leads/admin-leads.component').then(
        m => m.AdminLeadsComponent
      )
  },
  {
    path: '**',
    redirectTo: 'landing'
  }
];
